<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Login</router-link> |
    </div> -->
    <router-view />
  </div>
</template>

<script>
import EventBus from "./core/EventBus";
export default {
  name: "App",
  props: {},
  data() {
    return {
      user: null,
      isSSO: this.$store.getters.isSSO
    };
  },
  methods: {
    makeToast(message, isSuccess) {
      const variant = isSuccess ? "success" : "danger";
      this.$bvToast.toast(message, {
        variant: variant,
        solid: true,
        toaster: "b-toaster-bottom-right",
        noCloseButton: true,
        autoHideDelay: isSuccess ? 3000 : 5000
      });
    }
  },
  mounted() {
    new EventBus().subscribe("NOTIFICATION", data => {
      this.makeToast(data.message, data.success);
    });
    this.user = this.$store.getters.getUser;
  }
};
</script>
<style>
.centered-azc-benner {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
</style>
